﻿import {String} from "../../Tools/Misc.js"
import {RoleModel} from "./RoleModel";

export class CompteModel {
    public Primarykey: string = String.GetEmptyGuid;
    public Nom: string = "";
    public Prenom: string = "";
    public Mobilenumber: string = "";
    public Email?: string = "";
    public FkClient?: string = "";
    public ClientLibelle?: string = "";
    public Roles: Array<RoleModel> = [];
    public Issuer?: string;
    public Audience?: string;
    public Password?: string;
}